import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { FormControlLabel, Radio } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  selected: {
    color: theme.palette.primary.main,
  },
}));

const MainRadio = (props) => {
  const { labelKey, value, onChange, disabled, checked } = props;

  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <FormControlLabel
      value={value}
      control={(
        <Radio
          className={classes.root}
          color="primary"
          checked={checked}
          disabled={disabled}
        />
      )}
      onChange={(e, data) => onChange({ e, data })}
      label={(
        <p className={cn({
          [classes.selected]: checked,
        })}
        >
          {t(labelKey)}
        </p>
      )}
    />
  );
};

export default MainRadio;

MainRadio.propTypes = {
  labelKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
};

MainRadio.defaultProps = {
  labelKey: '',
  disabled: false,
};
